"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storeErpQueries = exports.storeErpQueryKeys = void 0;
const store_erp_api_1 = require("./store-erp.api");
exports.storeErpQueryKeys = {
    all: () => ['product'],
    availabilityForCurrentStore: ({ storeNumber, storeId, productId }) => [...exports.storeErpQueryKeys.all(), 'currentStore', storeNumber, storeId, productId],
    availabilityForAllStores: ({ skuId }) => [...exports.storeErpQueryKeys.all(), 'allStores', skuId],
};
const storeErpQueries = (apiOptions) => ({
    getProductAvailabilityForCurrentStore: (params, options = {}) => (Object.assign(Object.assign({}, options), { queryKey: exports.storeErpQueryKeys.availabilityForCurrentStore(params), queryFn: () => (0, store_erp_api_1.getProductAvailabilityForCurrentStore)(apiOptions, params) })),
    getProductAvailabilityForAllStores: (params, options = {}) => (Object.assign(Object.assign({}, options), { queryKey: exports.storeErpQueryKeys.availabilityForAllStores(params), queryFn: () => (0, store_erp_api_1.getProductAvailabilityForAllStores)(apiOptions, params) })),
});
exports.storeErpQueries = storeErpQueries;
//# sourceMappingURL=store-erp.queries.js.map